// extracted by css-extract-rspack-plugin
export default {"carousel":"_f06a5f07"};